/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A status and its evaluation rank, from workflows.constants.STATUS_RANKS.
 * @export
 * @interface StatusMeta
 */
export interface StatusMeta {
    /**
     * 
     * @type {string}
     * @memberof StatusMeta
     */
    value: string;
    /**
     * 
     * @type {number}
     * @memberof StatusMeta
     */
    rank: number;
}

/**
 * Check if a given object implements the StatusMeta interface.
 */
export function instanceOfStatusMeta(value: object): value is StatusMeta {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    return true;
}

export function StatusMetaFromJSON(json: any): StatusMeta {
    return StatusMetaFromJSONTyped(json, false);
}

export function StatusMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'rank': json['rank'],
    };
}

export function StatusMetaToJSON(json: any): StatusMeta {
    return StatusMetaToJSONTyped(json, false);
}

export function StatusMetaToJSONTyped(value?: StatusMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'rank': value['rank'],
    };
}

